import { Component, EventEmitter, Output } from '@angular/core';
import moment from 'moment';
import { xpoDateTimeFormatter } from '../../../../../../formatters';
import { XpoConditionBase } from '../../../../validations/validations.class';
import { XpoFilterCondition } from '../../../condition';
import { filterFormats, Operators, OperatorText, XpoFilterConditionCriteria } from './../../../../../models';

interface DateTimeModel {
  date: Date | null;
  time: string;
}

@Component({
  templateUrl: './after-same.component.html',
  styleUrls: ['../../validator.scss'],
})
export class XpoConditionDateTimeAfterSameComponent extends XpoConditionBase implements XpoFilterCondition {
  static text: string = OperatorText.OnOrAfter;
  static operator = Operators.OnOrAfter;

  isNegative = false;
  model: DateTimeModel = {
    date: null,
    time: '',
  };

  @Output() inputChanged = new EventEmitter();

  constructor() {
    super(filterFormats.default, true, true);
  }

  validate(cellValue): boolean {
    // Do not validate if input is empty
    if (!this.model) {
      return true;
    }

    if (!cellValue) {
      return false;
    }

    return moment(cellValue)
      .startOf('day')
      .isSameOrAfter(moment(`${this.model.date} ${this.model.time}`));
  }
  getCriteria(): XpoFilterConditionCriteria {
    return {
      operator: Operators.OnOrAfter,
      value: this.model,
      display: xpoDateTimeFormatter(moment(`${this.model.date} ${this.model.time}`)),
    };
  }
  onInputChange(): any {
    this.validateFormat();
    this.inputChanged.emit(this.model);
  }
}
